import { INVALIDATE_FLOW_VARIABLES, SET_FLOW_VARIABLES, SET_FLOW_VARIABLES_LOADING } from '../types';
import { invalidateFlowVariablesCache } from 'Utils/flowVariablesCache';

export const setFlowVariables = (flowId, variables) => (dispatch) => {
  dispatch({
    type: SET_FLOW_VARIABLES,
    payload: {
      flowId,
      variables,
    },
  });
};

export const invalidateFlowVariables = (flowId = null) => (dispatch) => {
  invalidateFlowVariablesCache(flowId);

  dispatch({
    type: INVALIDATE_FLOW_VARIABLES,
    payload: flowId,
  });
};

export const setFlowVariablesLoading = (isLoading) => (dispatch) => {
  dispatch({
    type: SET_FLOW_VARIABLES_LOADING,
    payload: isLoading,
  });
};
